import React, { useState } from "react";
import "../../styles/Brands-p.css";

const importAll = (r) => {
  return r.keys().map(r);
};

const images = importAll(
  require.context(
    "../../img/brands/government",
    false,
    /\.(webp|jpg|jpeg|png)$/
  )
);

const Government = () => {
  const [zoomedImg, setZoomedImg] = useState(null); // Estado para controlar el zoom de las imágenes

  // Función para hacer zoom en la imagen
  const handleImageClick = (image) => {
    setZoomedImg(image);
  };

  // Función para cerrar el zoom
  const handleCloseZoom = () => {
    setZoomedImg(null);
  };

  return (
    <div className="netflix-gallery">
      {/* Título y subtítulo */}
      <div className="gallery-header">
        <h1 className="gallery-title">Open Government Partnership</h1>
        <h2 className="gallery-subtitle">
        Freelance
        </h2>
        <h2 className="gallery-text">   In 2019, OGP launched Break the Roles, a campaign asking all of us to
          strengthen the gender perspectives in our commitments and increase
          women’s voices across open government. Our goal was for at least 30
          percent of members taking meaningful action on gender and inclusion by
          the end of the year. Prior to the campaign, of the nearly 4,000 open
          government reforms, covering everything from extractives to
          anti-corruption, less than two percent dealt with gender. Thanks to
          our members and partners not only met this goal but gender and
          inclusion were also the most popular issues areas addressed in
          incoming 2020 Action Plans.</h2>
      </div>
      {/* Galería de imágenes */}
      <div className="brands-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Brand ${index}`}
            className={`brand-img img-${index % 5}`}
            onClick={() => handleImageClick(image)} // Al hacer clic, hacemos zoom
          />
        ))}
      </div>

      {/* Imagen con zoom */}
      {zoomedImg && (
        <div className="zoom-overlay" onClick={handleCloseZoom}>
          <img src={zoomedImg} alt="Zoomed" className="zoomed-img" />
        </div>
      )}
    </div>
  );
};

export default Government;
